/**
 * @description
 * Objeto Fieldlinks
 */

import { Xmlfields } from "./xmlfields.model";

export class Fieldlinks {
    public id:number = null;
    public code:string = "";
    public description:string;
    public ymlkey:string;
    public icon:string;
    public url:string;
    public xmlfields: Xmlfields[] = [];
  
    constructor() {}
}